import React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";
import RevealOnScroll from "./RevealOnScroll";
import CaseStudySlide from "./CaseStudySlide";

const caseStudiesData = [
  {
    logo: process.env.PUBLIC_URL + "/SilberbergLogo.png",
    title: "Hotel Restaurant Silberberg",
    tag: "Gastronomie & Hotellerie",
    gradient: "from-[#2c4a52] to-[#4a9da8]",
    situation:
      "Aufbau einer professionellen Social-Media- und Web-Präsenz für ein Hotel-Restaurant.",
    solution:
      "Konzeption und vollständiger Aufbau der Social-Media-Präsenz auf Instagram und Facebook. Laufende Betreuung der Kanäle inklusive Content-Strategie, Gestaltung von Beiträgen, Reels und grafischen Inhalten. Zusätzlich Umsetzung und Aufbau der Website sowie Entwicklung eines einheitlichen visuellen Designs für den gesamten Online-Auftritt.",
    results: [
      "Community von über 1.000 Followern aufgebaut",
      "Einheitliches visuelles Design für alle Kanäle und Website",
      "Kontinuierliche Betreuung mit Content-Strategie und Reels",
    ],
  },
  {
    logo: process.env.PUBLIC_URL + "/RZPelletsLogo.png",
    title: "RZ Pellets",
    tag: "Energie & Handel",
    gradient: "from-[#4a9da8] to-[#3d5d66]",
    situation:
      "Stärkung der Online-Präsenz und professionelle Pflege der Social-Media-Kanäle.",
    solution:
      "Ganzheitliche Betreuung der Social-Media-Kanäle (Instagram und Facebook) mit Fokus auf Content-Erstellung, Beitragsgestaltung und laufende Pflege der Profile. Zusätzlich Erweiterung und Optimierung der bestehenden Website zur Verbesserung der Online-Präsenz und Kommunikation des Unternehmens.",
    results: [
      "Optimierte Website für bessere Online-Präsenz",
      "Laufende Content-Erstellung und Beitragsgestaltung",
      "Einheitliche Kommunikation über alle Kanäle",
    ],
  },
  {
    logo: process.env.PUBLIC_URL + "/WALTRAUD.png",
    title: "Kosmetikstudio WALTRAUD",
    tag: "Social Media Betreuung",
    gradient: "from-[#c4a4a8] to-[#4a9da8]",
    situation:
      "Aufbau und professionelle Betreuung der Social-Media-Präsenz zur Stärkung der Online-Sichtbarkeit und Kundenbindung.",
    solution:
      "Ganzheitliche Betreuung der Social-Media-Kanäle (Instagram und Facebook) mit Fokus auf Content-Planung, Gestaltung von Beiträgen und laufende Pflege der Profile. Kontinuierliche Weiterentwicklung der Inhalte zur Verbesserung von Reichweite und Interaktion.",
    results: [
      "Kontinuierliche und professionelle Präsenz auf Instagram und Facebook",
      "Laufende Content-Erstellung und strukturierte Beitragsplanung",
      "Verbesserte Online-Wahrnehmung und Kundenansprache",
    ],
  },
  {
    logo: process.env.PUBLIC_URL + "/harrys_logo.png",
    title: "Mode Harrys",
    tag: "Einzelhandel & Mode",
    gradient: "from-[#2c4a52] to-[#c4a4a8]",
    situation:
      "Vor der Zusammenarbeit fehlte es an nennenswerter Reichweite und einer klaren Social-Media-Präsenz. Der modeorientierte Einzelhandel war online kaum sichtbar und erreichte sein Kundenpublikum nur begrenzt.",
    solution:
      "Wir haben den Social-Media-Auftritt auf Instagram und Facebook professionell aufgebaut und betreuen ihn laufend: abgestimmte Content-Planung, Gestaltung der Beiträge und regelmäßige Pflege der Profile – im Einklang mit Marke, Sortiment und Zielgruppe.",
    results: [
      "Professionelle, durchgängige Präsenz auf Instagram und Facebook",
      "Strukturierte Content-Erstellung und Beitragsplanung",
      "Verbesserte Online-Sichtbarkeit und stärkere Ansprache der Zielgruppe",
    ],
  },
];

function CaseStudies() {
  return (
    <section
      id="referenzen"
      className="section-spacing bg-white relative overflow-hidden"
    >
      <div className="absolute top-20 left-0 w-96 h-96 bg-[#4a9da8]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 right-0 w-96 h-96 bg-[#2c4a52]/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container-custom relative z-10">
        <div className="max-w-7xl mx-auto">
          <RevealOnScroll className="text-center mb-16 md:mb-20">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full border border-[#4a9da8]/20">
                Success Stories
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-[#0f1419] mb-6">
              Messbare <span className="gradient-text">Erfolge</span>
            </h2>
            <p className="text-xl text-[#3a3a3a]/70 max-w-3xl mx-auto">
              Transparente Ergebnisse aus erfolgreichen Projekten
            </p>
          </RevealOnScroll>

          <div className="relative px-4 md:px-12">
            <Carousel
              opts={{
                align: "start",
                loop: true,
                dragFree: false,
              }}
              className="w-full"
            >
              <CarouselContent className="-ml-2 md:-ml-4">
                {caseStudiesData.map(function (study, index) {
                  return (
                    <CaseStudySlide
                      key={index}
                      study={study}
                      index={index}
                    />
                  );
                })}
              </CarouselContent>
              <CarouselPrevious className="left-0 md:-left-12 border-2 border-[#e8e4dc] bg-white text-[#0f1419] hover:bg-[#f5f5f5] hover:border-[#4a9da8]/30 hover:text-[#4a9da8]" />
              <CarouselNext className="right-0 md:-right-12 border-2 border-[#e8e4dc] bg-white text-[#0f1419] hover:bg-[#f5f5f5] hover:border-[#4a9da8]/30 hover:text-[#4a9da8]" />
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CaseStudies;
